import { defineStore } from 'pinia';

export const useUpdateStore = defineStore('update', {
  state: () => ({
    version: null,
    mismatch: false,
    refresh_version: null,
    refresh_version_mismatch: false,
    active_company_mismatch: false,
    update_notification_version: null,
    company_owner_changed: false,
  }),

  actions: {
    setVersion(value) {
      this.version = value;
    },

    setMismatch(value) {
      this.mismatch = value;
    },

    setRefreshVersion(value) {
      this.refresh_version = value;
    },

    setUpdateNotificationVersion(value) {
      this.update_notification_version = value;
    },

    setRefreshVersionMismatch(value) {
      this.refresh_version_mismatch = value;
    },

    setActiveCompanyMismatch(value) {
      this.active_company_mismatch = value;
    },

    setCompanyOwnerChanged(value) {
      this.company_owner_changed = value;
    },
  },
});
